import { render, staticRenderFns } from "./VFlagMeta.vue?vue&type=template&id=0fa8aca6&"
import script from "./VFlagMeta.vue?vue&type=script&lang=js&"
export * from "./VFlagMeta.vue?vue&type=script&lang=js&"
import style0 from "./VFlagMeta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports